import { useTheme, Theme, GlobalStyles as MuiGlobalStyles } from "@mui/material"
// import { colors } from "src/theme"

const styles = (theme: Theme) => ({
  a: {
    fontWeight: 500,
    textDecoration: "inherit"
  },
  body: {
    margin: 0,
    display: "flex",
    placeItems: "center",
    minWidth: "320px",
    minHeight: "100vh"
  }, // app.css here
  "#root": {
    width: "100%",
    height: "100%"
  },
  ".error-row": {
    backgroundColor: theme.palette.error.light,
    opacity: 0.8,
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: theme.palette.error.main,
      opacity: 1
    },
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: "4px"
  },
  ".Mui-disabled": {
    pointerEvents: "auto !important"
  },
  ".hovered-scrollbar": {
    "&:hover::-webkit-scrollbar": {
      display: "unset"
    },
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  ".hovered-scrollbar2": {
    "&:hover ::-webkit-scrollbar": {
      display: "unset"
    },
    "& ::-webkit-scrollbar": {
      display: "none"
    }
  },
  "&::-webkit-scrollbar": {
    width: 4,
    height: 4
  }, //end
  "&::-webkit-scrollbar-track": {
    WebkitBoxShadow: `inset 0 0 6px rgba(0,0,0,0.00)`
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.primary.light, //theme.palette.primary.main,
    borderRadius: 2
  },
  ".hide-scroll": {
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },

  ".custom-scroll": {
    "&::-webkit-scrollbar": {
      width: 4,
      height: 4
    },
    "&::-webkit-scrollbar-track": {
      WebkitBoxShadow: `inset 0 0 6px ${theme.palette.scrollbar?.track}`
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.scrollbar?.thumb,
      borderRadius: 16
    }
  },
  ".numberinput": {
    "& input[type=number]": {},
    "& input[type=number]::-webkit-outer-spin-button": {
      display: "none",
      margin: 0
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      display: "none",
      margin: 0
    }
  }
})
const GlobalStyle = () => {
  const theme = useTheme()
  const style = styles(theme)
  return <MuiGlobalStyles styles={style} />
}

export default GlobalStyle
